import { API_BASE } from '../config';

export async function fetchCreditBalance(token: string): Promise<number | null> {
  try {
    const response = await fetch(`${API_BASE}/api/credits-activity/balance`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      return null;
    }

    const data = await response.json();
    return data.balance ?? 0;
  } catch {
    return null;
  }
}

export function hasEnoughCredits(balance: number, requiredCredits = 0): boolean {
  if (balance <= 0) {
    return false;
  }
  if (requiredCredits <= 0) {
    return true;
  }
  return balance >= requiredCredits;
}
